class LocationFiltersController {

  constructor(LocationFiltersService, AlertService, LoaderService) {
    this.LocationFiltersService = LocationFiltersService;
    this.AlertService = AlertService;
    this.LoaderService = LoaderService;
  }
  
  $onInit() {
    var self = this;
    self.LoaderService.start();
    self.LocationFiltersService.get()
        .then( (locationFilters) => self.locationFilters = locationFilters )
        .catch( (error) => self.AlertService.error("There was a problem getting the filters") )
        .finally( ()=> self.LoaderService.stop() );
  }
}
LocationFiltersController.$inject = ['LocationFiltersService', 'AlertService', 'LoaderService'];
export default LocationFiltersController;
